/* eslint-disable react/no-array-index-key, consistent-return, @typescript-eslint/no-shadow, prettier/prettier, @typescript-eslint/no-unused-vars */
import React from 'react';
import { useStyletron } from 'baseui';
import { IZkChangeLog } from '../../../utils/types';
import { formatDate, formatJson } from '../../../utils/formatters';

interface HistoryTabProps {
	changes: IZkChangeLog[];
}

const HistoryTab: React.FC<HistoryTabProps> = ({ changes }) => {
	const [css] = useStyletron();

	if (!changes?.length) {
		return <div className={css({ padding: '24px', color: '#666' })}>No recent changes found for this config key.</div>;
	}

	return (
		<div className={css({ padding: '16px' })}>
			{changes.map((change, idx) => (
				<div
					key={idx}
					className={css({
						display: 'flex',
						borderLeft: '3px solid #276EF1',
						paddingLeft: '16px',
						marginBottom: '20px',
						position: 'relative' as const
					})}>
					<div
						className={css({
							position: 'absolute' as const,
							left: '-6px',
							top: '0',
							width: '10px',
							height: '10px',
							borderRadius: '50%',
							backgroundColor: '#276EF1'
						})}
					/>
					<div className={css({ flex: '1' })}>
						<div
							className={css({
								display: 'flex',
								justifyContent: 'space-between',
								marginBottom: '8px'
							})}>
							<span className={css({ fontSize: '14px', fontWeight: 600 })}>{change.serviceName}</span>
							<span className={css({ fontSize: '13px', color: '#666' })}>{formatDate(change.eventTime)}</span>
						</div>
						<div
							className={css({
								display: 'grid',
								gridTemplateColumns: '1fr 1fr',
								gap: '8px'
							})}>
							<div
								className={css({
									backgroundColor: '#FFF3F0',
									padding: '8px 12px',
									borderRadius: '6px',
									fontSize: '13px',
									fontFamily: 'monospace'
								})}>
								<div className={css({ color: '#999', fontSize: '11px', marginBottom: '4px' })}>Old Value</div>
								{formatJson(change.oldValue)}
							</div>
							<div
								className={css({
									backgroundColor: '#F0FFF4',
									padding: '8px 12px',
									borderRadius: '6px',
									fontSize: '13px',
									fontFamily: 'monospace'
								})}>
								<div className={css({ color: '#999', fontSize: '11px', marginBottom: '4px' })}>New Value</div>
								{formatJson(change.newValue)}
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default HistoryTab;
